import React from 'react';
// styles
import styled, { css } from 'styled-components';
// state
import { useSoFormStepsState } from '../../SoForm.context';
// components
import SoFormStepComplements from '../../steps/complements/SoFormStepComplements';
import SoFormStepComplementsFooter from '../../steps/complements/SoFormStepComplementsFooter';
import SoFormStepConfiguration from '../../steps/configuration/SoFormStepConfiguration';
import SoFormStepConfigurationFooter from '../../steps/configuration/SoFormStepConfigurationFooter';
import SoFormStepConfirmation from '../../steps/confirmation/SoFormStepConfirmation';
import SoFormStepConfirmationFooter from '../../steps/confirmation/SoFormStepConfirmationFooter';
import SoFormStepPrice from '../../steps/price/SoFormStepPrice';
import SoFormStepPriceFooter from '../../steps/price/SoFormStepPriceFooter';
import SoFormStepSuccess from '../../steps/success/SoFormStepSuccess';
import SoFormStepSuccessFooter from '../../steps/success/SoFormStepSuccessFooter';

const SoFormFooter = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const currentStep = stepsState.currentStep;
  if (!!currentStep.hideFooter) return <></>;
  return (
    <div className={className}>
      {currentStep.nameForData === SoFormStepConfiguration.nameForData && (
        <SoFormStepConfigurationFooter />
      )}
      {currentStep.nameForData === SoFormStepPrice.nameForData && (
        <SoFormStepPriceFooter />
      )}
      {currentStep.nameForData === SoFormStepComplements.nameForData && (
        <SoFormStepComplementsFooter />
      )}
      {currentStep.nameForData === SoFormStepConfirmation.nameForData && (
        <SoFormStepConfirmationFooter />
      )}
      {currentStep.nameForData === SoFormStepSuccess.nameForData && (
        <SoFormStepSuccessFooter />
      )}
    </div>
  );
};

const regularCSS = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--white);
  border-top: 1px solid var(--grey300);
  width: 100%;
`;

export default styled(SoFormFooter)`
  ${regularCSS}
`;
